import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { IHistory } from '../models/history.model';

const routes = {
  history: () => `/v1/history`
};

@Injectable({
  providedIn: 'root'
})
export class HistoryService {

  constructor(private http: HttpClient) { }

  getHistory(id: number, entityName: string): Observable<IHistory[]> {

    const params = new HttpParams()
      .set('entityId', id)
      .set('tableNameEntity', entityName);

    return this.http.get<IHistory[]>(routes.history(), { params }).pipe(
      map((res: IHistory[]) => {
        return res.map((item: IHistory) => {
          return {
            ...item,
            changesArray: JSON.parse(item.changes)
          }
        });
      }));
  }
}
